module.exports = __webpack_public_path__ + "static/media/olin.be7201c4.png";